/* Atlas Mock Data & Utilities — GII Portfolio (frontend-only) */

const STORAGE_KEYS = {
  deals: "atlas_deals",
  portfolio: "atlas_portfolio",
  lps: "atlas_lps",
  audit: "atlas_audit",
  activities: "atlas_activities",
};

const stages = ["Sourced", "Contacted", "Evaluating", "IC Ready", "LOI", "Closed"];

function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

// ─── GII Real Portfolio Companies ────────────────────────────────────────────
// Based on deep-research-report.md categorization:
// PE Investments: Majority buyouts, growth equity in established companies
// VC Investments: Seed, Series A-C in startups/growth-stage companies

const GII_PORTFOLIO = [
  // ========== PE INVESTMENTS ==========
  {
    id: "P201",
    name: "Al Meswak Dental Clinics",
    sector: "Healthcare",
    country: "Saudi Arabia",
    investmentType: "PE", // Majority buyout - May 2022
    description: "The largest dental and dermatology service provider in Saudi Arabia, offering integrated oral, dermatological, and laser care across 90+ facilities.",
    founded: "2000",
    employees: "700+",
    keyMetrics: "90+ facilities, 37 cities, 450,000 patients/yr",
    dealSize: "$530M (51% stake)",
    dealType: "Buyout",
    dealDate: "May 2022",
    website: "https://almeswak.com",
    recentNews: "GCC expansion into Abu Dhabi; targeting Saudi Stock Exchange listing in 2–3 years.",
    irr: 22.4,
    moic: 1.8,
    revenue: 185,
    ebitda: 48,
    valueDrivers: ["GCC Expansion", "IPO Readiness", "Clinic Network"],
    exitReadiness: 68,
    status: "Active",
    geography: "MEA",
  },
  {
    id: "P202",
    name: "Abeer Medical Company",
    sector: "Healthcare",
    country: "Saudi Arabia",
    investmentType: "PE", // Growth stake - SAR 600M - Jan 2024
    description: "A multinational healthcare organization operating medical centers and hospitals across Saudi Arabia and the GCC — one of the largest affordable healthcare providers in the region.",
    founded: "1999",
    employees: "1,000–5,000",
    keyMetrics: "14 medical centers, 2 hospitals, 50 healthcare facilities",
    dealSize: "SAR 600M stake (~$160M)",
    dealType: "Growth (stake)",
    dealDate: "January 2024",
    website: "https://www.abeergroup.com",
    recentNews: "GII invested SAR 600M in January 2024 to expand Abeer's network of hospitals and medical centers across KSA.",
    irr: 18.1,
    moic: 1.3,
    revenue: 210,
    ebitda: 52,
    valueDrivers: ["Hospital Expansion", "Affordable Care", "KSA Platform"],
    exitReadiness: 42,
    status: "Active",
    geography: "MEA",
  },
  {
    id: "P208",
    name: "Emad Bakeries",
    sector: "Food Processing",
    country: "Saudi Arabia",
    investmentType: "PE", // GreenCorp platform acquisition - Mar 2024
    description: "The largest industrial fresh flatbread bakery in western Saudi Arabia, producing Arabic bread and pastries from Jeddah with plans for national and international expansion.",
    founded: "1975",
    employees: "400+",
    keyMetrics: "Largest flatbread producer in western KSA; expansion across Kingdom and internationally",
    dealSize: "GreenCorp platform ($150M fund)",
    dealType: "Acquisition",
    dealDate: "March 2024",
    website: "https://www.emadbakeries.com",
    recentNews: "Acquired by GreenCorp (GII-backed) in March 2024 to strengthen regional food security.",
    irr: 14.2,
    moic: 1.2,
    revenue: 45,
    ebitda: 8,
    valueDrivers: ["National Rollout", "Operational Efficiency", "Export Markets"],
    exitReadiness: 25,
    status: "Active",
    geography: "MEA",
  },
  {
    id: "P210",
    name: "GEMS Education",
    sector: "Education",
    country: "United Arab Emirates",
    investmentType: "PE", // Brookfield-led consortium - Jul 2024
    description: "One of the world's largest K–12 private education providers, operating 200,000+ students across the Middle East, North Africa, Asia, Europe, and North America since 1959.",
    founded: "1959",
    employees: "~15,900",
    keyMetrics: "200,000 students, $1.4B revenue (2024), global footprint",
    dealSize: "$3.25B financing facility (Brookfield-led consortium)",
    dealType: "PE Investment",
    dealDate: "July 2024",
    website: "https://www.gemseducation.com",
    recentNews: "GII finalized its consortium investment in July 2024 alongside Brookfield, securing a $3.25B UAE bank financing facility.",
    irr: 17.5,
    moic: 1.4,
    revenue: 1400,
    ebitda: 280,
    valueDrivers: ["Enrollment Growth", "Curriculum Premium", "Regional Expansion"],
    exitReadiness: 60,
    status: "Active",
    geography: "MEA",
  },
  {
    id: "P211",
    name: "LogiPoint JV",
    sector: "Logistics",
    country: "Saudi Arabia",
    investmentType: "PE", // JV - June 2024
    description: "Joint venture with SISCO to build Grade-A warehouses across Riyadh and Jeddah, supporting Saudi logistics infrastructure growth.",
    founded: "2024",
    employees: "50+",
    keyMetrics: "SR 1.0 bn+ investment, Grade-A warehousing, Riyadh & Jeddah",
    dealSize: "SR ≥1.0 bn (~$270M)",
    dealType: "Joint Venture",
    dealDate: "June 2024",
    website: "https://logipoint.com",
    recentNews: "New JV launched Jun 2024 to build Grade-A warehouses supporting Saudi Vision 2030 logistics growth.",
    irr: 15.5,
    moic: 1.3,
    revenue: 35,
    ebitda: 10,
    valueDrivers: ["Vision 2030", "Warehousing Infrastructure", "E-commerce Growth"],
    exitReadiness: 20,
    status: "Active",
    geography: "MEA",
  },

  // ========== VC INVESTMENTS ==========
  {
    id: "P203",
    name: "Epik Foods",
    sector: "Food & Beverage",
    country: "United Arab Emirates",
    investmentType: "VC", // Co-founder + Growth PE - 2023
    description: "A UAE-headquartered F&B platform operating 100+ distinct brands across 30+ locations in the UAE and Saudi Arabia, spanning virtual brands, dine-in restaurants, and meal plans.",
    founded: "2017",
    employees: "1,000+",
    keyMetrics: "100+ brands, 30+ locations, 5M+ meals served annually",
    dealSize: "$15.5M (GII co-founder + Ruya Partners)",
    dealType: "Growth/PE",
    dealDate: "December 2023",
    website: "https://www.epikfoods.com",
    recentNews: "Secured $15.5M from Ruya Partners in November 2024 to accelerate KSA expansion.",
    irr: 31.2,
    moic: 2.1,
    revenue: 62,
    ebitda: 9,
    valueDrivers: ["KSA Expansion", "Brand Portfolio", "Virtual Kitchens"],
    exitReadiness: 38,
    status: "Active",
    geography: "MEA",
  },
  {
    id: "P204",
    name: "Bombay Shaving Company",
    sector: "Consumer / Personal Care",
    country: "India",
    investmentType: "VC", // Series C - Feb 2022
    description: "A premium personal care and grooming brand offering shave care, beard care, and skincare products. Targeting INR 200Cr revenue with MENA expansion underway.",
    founded: "2015",
    employees: "200–400",
    keyMetrics: "INR 200Cr revenue FY24, 100+ SKUs, IPO track",
    dealSize: "INR 50Cr Series C (~$6.6M)",
    dealType: "Growth (Series C)",
    dealDate: "February 2022",
    website: "https://www.bombayshavingcompany.com",
    recentNews: "Raised INR 136Cr in November 2025; crossed INR 200Cr revenue in FY24; IPO planned in 18–24 months.",
    irr: 24.7,
    moic: 2.4,
    revenue: 24,
    ebitda: 3,
    valueDrivers: ["MENA Entry", "D2C Growth", "IPO Readiness"],
    exitReadiness: 55,
    status: "Active",
    geography: "APAC",
  },
  {
    id: "P205",
    name: "Soothe Healthcare (Paree)",
    sector: "Consumer Goods / Healthcare",
    country: "India",
    investmentType: "VC", // Series C ext. - Aug 2021
    description: "Maker of Paree™ sanitary pads and baby diapers, serving India's mass-market feminine hygiene segment. Annual revenue of ₹153Cr with strong distribution across online and offline channels.",
    founded: "2012",
    employees: "~400",
    keyMetrics: "₹153Cr revenue (FY24), 398 employees, 12 funding rounds",
    dealSize: "₹100Cr Series C ext. (~$13M)",
    dealType: "Growth (Series C ext.)",
    dealDate: "August 2021",
    website: "https://soothehealthcare.com",
    recentNews: "Launched Paree Super Nights in January 2024; expanding rural distribution network.",
    irr: 19.3,
    moic: 1.9,
    revenue: 18,
    ebitda: 2,
    valueDrivers: ["Rural Distribution", "Product Line Expansion", "Brand Awareness"],
    exitReadiness: 48,
    status: "Active",
    geography: "APAC",
  },
  {
    id: "P206",
    name: "zSpace, Inc.",
    sector: "Education Technology",
    country: "United States",
    investmentType: "VC", // VC + SPAC - Q2 2019
    description: "An AR/VR EdTech company delivering immersive STEM and career readiness programs to K–12 schools. Publicly listed on Nasdaq (ZSPC) since December 2022.",
    founded: "2007",
    employees: "51–200",
    keyMetrics: "2,400+ school customers, 94% of top 100 US districts, 80+ patents, $27.9M revenue",
    dealSize: "VC + SPAC merger ($195M pro forma)",
    dealType: "Series C (VC); SPAC merger",
    dealDate: "Q2 2019",
    website: "https://zspace.com",
    recentNews: "Nasdaq IPO completed December 2022; secured $4.3M senior debt financing in March 2026.",
    irr: 28.5,
    moic: 3.2,
    revenue: 28,
    ebitda: 4,
    valueDrivers: ["Public Market Premium", "District Penetration", "Curriculum Expansion"],
    exitReadiness: 90,
    status: "Active",
    geography: "US",
  },
  {
    id: "P207",
    name: "Badia Farms",
    sector: "AgriTech",
    country: "United Arab Emirates",
    investmentType: "VC", // GreenCorp stake - May 2023
    description: "The Middle East's first high-tech indoor vertical farm, producing pesticide-free fruits, vegetables, and micro-greens year-round using hydroponic techniques.",
    founded: "2016",
    employees: "11–50",
    keyMetrics: "50,000 sq ft farm, 3,500 kg/day capacity, 236k sq ft expansion plot",
    dealSize: "Undisclosed stake (GreenCorp platform)",
    dealType: "Growth (stake)",
    dealDate: "May 2023",
    website: "https://badia.shop",
    recentNews: "27-year strategic agreement signed with Food Tech Valley in October 2024; Bahrain expansion via Edamah partnership.",
    irr: 16.8,
    moic: 1.5,
    revenue: 8,
    ebitda: 1,
    valueDrivers: ["GCC Food Security", "KSA Expansion", "Pesticide-Free Premium"],
    exitReadiness: 30,
    status: "Active",
    geography: "MEA",
  },
  {
    id: "P209",
    name: "Invygo",
    sector: "Mobility / Automotive",
    country: "United Arab Emirates",
    investmentType: "VC", // Seed - Nov 2019
    description: "MENA's first and largest car subscription platform, offering all-inclusive monthly subscriptions that simplify vehicle access for individuals and corporates across the UAE and KSA.",
    founded: "2018",
    employees: "~125",
    keyMetrics: "20,000+ subscribers, $5.3M ARR (2026)",
    dealSize: "$1M Seed",
    dealType: "Seed",
    dealDate: "November 2019",
    website: "https://www.invygo.com",
    recentNews: "Raised $8M Series A extension in October 2024 to pursue profitability and regional expansion.",
    irr: 21.6,
    moic: 2.8,
    revenue: 5,
    ebitda: -1,
    valueDrivers: ["Subscriber Growth", "KSA Expansion", "Fleet Partnerships"],
    exitReadiness: 40,
    status: "Active",
    geography: "MEA",
  },
  {
    id: "P212",
    name: "Mumzworld",
    sector: "E-commerce",
    country: "United Arab Emirates",
    investmentType: "VC", // Series B - Oct 2018 (EXITED)
    description: "MENA's leading mother and baby e-commerce platform. GII became largest shareholder with $20M Series B investment.",
    founded: "2011",
    employees: "200+",
    keyMetrics: "MENA's largest mother/baby e-commerce, millions of customers",
    dealSize: "~$20 million Series B",
    dealType: "Series B (VC)",
    dealDate: "October 2018",
    website: "https://www.mumzworld.com",
    recentNews: "Successfully exited - sold to Saudi Tamer Group in 2021 in landmark regional e-commerce deal.",
    irr: 35.2,
    moic: 2.8,
    revenue: 0,
    ebitda: 0,
    valueDrivers: ["E-commerce Growth", "Regional Expansion", "Category Leadership"],
    exitReadiness: 100,
    status: "Exited",
    geography: "MEA",
  },
  {
    id: "P213",
    name: "Nysaa Retail (1-India Family Mart)",
    sector: "Retail",
    country: "India",
    investmentType: "VC", // Series B - Feb 2022
    description: "Operates 1-India Family Mart value fashion retail chain across India, targeting the mass-market apparel segment.",
    founded: "2019",
    employees: "500+",
    keyMetrics: "100+ stores, value fashion retail chain",
    dealSize: "₹50 crore (~$6.7M)",
    dealType: "Growth (Series B)",
    dealDate: "February 2022",
    website: "https://1indiafamilymart.com",
    recentNews: "Rapid store expansion across tier-2 and tier-3 Indian cities.",
    irr: 18.5,
    moic: 1.6,
    revenue: 32,
    ebitda: 3,
    valueDrivers: ["Store Expansion", "Value Retail", "Tier-2/3 Cities"],
    exitReadiness: 35,
    status: "Active",
    geography: "APAC",
  },
  {
    id: "P214",
    name: "UpScalio",
    sector: "E-commerce",
    country: "India",
    investmentType: "VC", // Bridge round - Mar 2022
    description: "E-commerce brands aggregator that acquires and scales online consumer brands across marketplaces.",
    founded: "2021",
    employees: "100+",
    keyMetrics: "Multiple brand acquisitions, marketplace aggregator model",
    dealSize: "$15.0 million",
    dealType: "Growth (bridge)",
    dealDate: "March 2022",
    website: "https://upscalio.com",
    recentNews: "GII led $15M bridge round as 6th investment from IGP-II to roll up online brands.",
    irr: 22.3,
    moic: 1.8,
    revenue: 15,
    ebitda: 1,
    valueDrivers: ["Brand Aggregation", "Marketplace Scale", "D2C Growth"],
    exitReadiness: 30,
    status: "Active",
    geography: "APAC",
  },
  {
    id: "P215",
    name: "Hero Electric",
    sector: "E-Mobility",
    country: "India",
    investmentType: "VC", // Growth - Nov 2023
    description: "India's leading electric two-wheeler manufacturer with strong distribution network and brand recognition.",
    founded: "2007",
    employees: "1,000+",
    keyMetrics: "Market leader in India EV two-wheelers, nationwide distribution",
    dealSize: "₹300 crore (~$36M, planned)",
    dealType: "Growth (planned)",
    dealDate: "November 2023",
    website: "https://heroelectric.in",
    recentNews: "GII (existing investor) reported to back ₹300cr equity raise; deal status unconfirmed.",
    irr: 20.1,
    moic: 1.7,
    revenue: 120,
    ebitda: 8,
    valueDrivers: ["EV Adoption", "Distribution Network", "Government Incentives"],
    exitReadiness: 45,
    status: "Active",
    geography: "APAC",
  },
  {
    id: "P216",
    name: "Nymi",
    sector: "Wearable Tech",
    country: "Canada",
    investmentType: "VC", // Minority stake - May 2017
    description: "Wearable authentication technology company with the Nymi Band for secure biometric identity verification.",
    founded: "2011",
    employees: "50+",
    keyMetrics: "11% stake acquired, enterprise authentication technology",
    dealSize: "Not disclosed (11% stake)",
    dealType: "Minority stake",
    dealDate: "May 2017",
    website: "https://nymi.com",
    recentNews: "GII Tech Ventures acquired 11% stake in biometric wearable company.",
    irr: 12.5,
    moic: 1.3,
    revenue: 5,
    ebitda: 0,
    valueDrivers: ["Enterprise Security", "Biometric Auth", "IoT Integration"],
    exitReadiness: 25,
    status: "Active",
    geography: "North America",
  },
];

// ─── GII Real Deal Pipeline ───────────────────────────────────────────────────
const GII_DEALS = [
  // ========== PE DEALS ==========
  {
    id: "D1001",
    name: "Al Meswak Dental Clinics",
    sector: "Healthcare",
    geography: "MEA",
    owners: "PE-backed",
    stage: "Closed",
    investmentType: "PE",
    score: 92,
    enterpriseValue: 530,
    ebitdaMargin: 26,
    revenueYoY: 18,
    updatedAt: Date.now() - 86400 * 700 * 1000,
    description: "Largest dental & dermatology chain in KSA. GII acquired 51% majority stake.",
  },
  {
    id: "D1002",
    name: "Abeer Medical Company",
    sector: "Healthcare",
    geography: "MEA",
    owners: "Founder-owned",
    stage: "Closed",
    investmentType: "PE",
    score: 88,
    enterpriseValue: 480,
    ebitdaMargin: 25,
    revenueYoY: 22,
    updatedAt: Date.now() - 86400 * 90 * 1000,
    description: "KSA hospital and medical center group. GII acquired significant equity stake for SAR 600M.",
  },
  {
    id: "D1008",
    name: "Emad Bakeries",
    sector: "Food Processing",
    geography: "MEA",
    owners: "Founder-owned",
    stage: "Closed",
    investmentType: "PE",
    score: 68,
    enterpriseValue: 60,
    ebitdaMargin: 18,
    revenueYoY: 12,
    updatedAt: Date.now() - 86400 * 60 * 1000,
    description: "Largest flatbread producer in western KSA. Acquired by GreenCorp platform in 2024.",
  },
  {
    id: "D1010",
    name: "GEMS Education",
    sector: "Education",
    geography: "MEA",
    owners: "PE-backed",
    stage: "Closed",
    investmentType: "PE",
    score: 83,
    enterpriseValue: 3250,
    ebitdaMargin: 20,
    revenueYoY: 9,
    updatedAt: Date.now() - 86400 * 30 * 1000,
    description: "Global K–12 education leader. GII joined Brookfield-led consortium in July 2024.",
  },
  {
    id: "D1012",
    name: "LogiPoint JV",
    sector: "Logistics",
    geography: "MEA",
    owners: "JV",
    stage: "Closed",
    investmentType: "PE",
    score: 78,
    enterpriseValue: 270,
    ebitdaMargin: 22,
    revenueYoY: 31,
    updatedAt: Date.now() - 86400 * 3 * 1000,
    description: "Grade-A warehousing JV targeting Riyadh and Jeddah logistics corridors.",
  },

  // ========== VC DEALS ==========
  {
    id: "D1003",
    name: "Epik Foods",
    sector: "Food & Beverage",
    geography: "MEA",
    owners: "Founder-owned",
    stage: "Closed",
    investmentType: "VC",
    score: 79,
    enterpriseValue: 80,
    ebitdaMargin: 14,
    revenueYoY: 35,
    updatedAt: Date.now() - 86400 * 120 * 1000,
    description: "UAE F&B platform co-founded with GII. 100+ brands across UAE and KSA.",
  },
  {
    id: "D1004",
    name: "Bombay Shaving Company",
    sector: "Consumer",
    geography: "APAC",
    owners: "VC-backed",
    stage: "Closed",
    investmentType: "VC",
    score: 76,
    enterpriseValue: 55,
    ebitdaMargin: 12,
    revenueYoY: 41,
    updatedAt: Date.now() - 86400 * 800 * 1000,
    description: "India premium grooming brand. GII led INR 50Cr Series C. MENA expansion planned.",
  },
  {
    id: "D1005",
    name: "Soothe Healthcare (Paree)",
    sector: "Consumer",
    geography: "APAC",
    owners: "VC-backed",
    stage: "Closed",
    investmentType: "VC",
    score: 74,
    enterpriseValue: 40,
    ebitdaMargin: 11,
    revenueYoY: 28,
    updatedAt: Date.now() - 86400 * 900 * 1000,
    description: "India feminine hygiene brand. GII led ₹100Cr Series C extension.",
  },
  {
    id: "D1006",
    name: "zSpace, Inc.",
    sector: "EdTech",
    geography: "US",
    owners: "VC-backed",
    stage: "Closed",
    investmentType: "VC",
    score: 85,
    enterpriseValue: 195,
    ebitdaMargin: 14,
    revenueYoY: 32,
    updatedAt: Date.now() - 86400 * 500 * 1000,
    description: "US AR/VR EdTech. GII is major shareholder. Nasdaq listed via SPAC (ZSPC).",
  },
  {
    id: "D1007",
    name: "Badia Farms",
    sector: "AgriTech",
    geography: "MEA",
    owners: "Founder-owned",
    stage: "Closed",
    investmentType: "VC",
    score: 71,
    enterpriseValue: 25,
    ebitdaMargin: 12,
    revenueYoY: 45,
    updatedAt: Date.now() - 86400 * 300 * 1000,
    description: "MENA's first vertical farm. GreenCorp (GII) acquired stake for GCC food security play.",
  },
  {
    id: "D1009",
    name: "Invygo",
    sector: "Mobility",
    geography: "MEA",
    owners: "VC-backed",
    stage: "Closed",
    investmentType: "VC",
    score: 77,
    enterpriseValue: 30,
    ebitdaMargin: -5,
    revenueYoY: 62,
    updatedAt: Date.now() - 86400 * 1500 * 1000,
    description: "MENA car subscription leader. GII seed investor. 20,000+ subscribers.",
  },
  {
    id: "D1017",
    name: "Mumzworld",
    sector: "E-commerce",
    geography: "MEA",
    owners: "VC-backed",
    stage: "Closed",
    investmentType: "VC",
    score: 86,
    enterpriseValue: 75,
    ebitdaMargin: 8,
    revenueYoY: 45,
    updatedAt: Date.now() - 86400 * 1200 * 1000,
    description: "MENA's largest mother/baby e-commerce. GII led $20M Series B. Exited to Tamer Group 2021.",
  },
  {
    id: "D1018",
    name: "Nysaa Retail (1-India Family Mart)",
    sector: "Retail",
    geography: "APAC",
    owners: "VC-backed",
    stage: "Closed",
    investmentType: "VC",
    score: 72,
    enterpriseValue: 35,
    ebitdaMargin: 9,
    revenueYoY: 38,
    updatedAt: Date.now() - 86400 * 700 * 1000,
    description: "India value fashion retail chain. GII invested ₹50cr Series B in Feb 2022.",
  },
  {
    id: "D1019",
    name: "UpScalio",
    sector: "E-commerce",
    geography: "APAC",
    owners: "VC-backed",
    stage: "Closed",
    investmentType: "VC",
    score: 74,
    enterpriseValue: 45,
    ebitdaMargin: 6,
    revenueYoY: 55,
    updatedAt: Date.now() - 86400 * 650 * 1000,
    description: "India e-commerce aggregator. GII led $15M bridge round in Mar 2022.",
  },
  {
    id: "D1020",
    name: "Hero Electric",
    sector: "E-Mobility",
    geography: "APAC",
    owners: "VC-backed",
    stage: "IC Ready",
    investmentType: "VC",
    score: 78,
    enterpriseValue: 150,
    ebitdaMargin: 7,
    revenueYoY: 42,
    updatedAt: Date.now() - 86400 * 90 * 1000,
    description: "India's leading EV two-wheeler manufacturer. GII backing ₹300cr raise.",
  },
  {
    id: "D1021",
    name: "Nymi",
    sector: "Wearable Tech",
    geography: "North America",
    owners: "VC-backed",
    stage: "Closed",
    investmentType: "VC",
    score: 65,
    enterpriseValue: 20,
    ebitdaMargin: 0,
    revenueYoY: 25,
    updatedAt: Date.now() - 86400 * 2000 * 1000,
    description: "Biometric wearable authentication. GII Tech Ventures acquired 11% stake in 2017.",
  },

  // ========== PIPELINE DEALS (Future) ==========
  {
    id: "D1011",
    name: "Saudi Specialty Pharma Co.",
    sector: "Healthcare",
    geography: "MEA",
    owners: "Founder-owned",
    stage: "Evaluating",
    investmentType: "PE",
    score: 81,
    enterpriseValue: 120,
    ebitdaMargin: 28,
    revenueYoY: 24,
    updatedAt: Date.now() - 86400 * 5 * 1000,
    description: "KSA specialty pharmaceutical manufacturer with strong domestic distribution.",
  },
  {
    id: "D1013",
    name: "India D2C Beauty Brand",
    sector: "Consumer",
    geography: "APAC",
    owners: "VC-backed",
    stage: "Evaluating",
    investmentType: "VC",
    score: 72,
    enterpriseValue: 35,
    ebitdaMargin: 8,
    revenueYoY: 55,
    updatedAt: Date.now() - 86400 * 8 * 1000,
    description: "Fast-growing India D2C beauty brand with strong social commerce traction.",
  },
  {
    id: "D1014",
    name: "MENA EdTech Platform",
    sector: "EdTech",
    geography: "MEA",
    owners: "VC-backed",
    stage: "Contacted",
    investmentType: "VC",
    score: 69,
    enterpriseValue: 45,
    ebitdaMargin: 5,
    revenueYoY: 78,
    updatedAt: Date.now() - 86400 * 12 * 1000,
    description: "Arabic-first online learning platform targeting K–12 and professional upskilling.",
  },
  {
    id: "D1015",
    name: "UAE Healthtech Startup",
    sector: "Healthcare",
    geography: "MEA",
    owners: "VC-backed",
    stage: "Sourced",
    investmentType: "VC",
    score: 65,
    enterpriseValue: 20,
    ebitdaMargin: -10,
    revenueYoY: 120,
    updatedAt: Date.now() - 86400 * 2 * 1000,
    description: "AI-powered diagnostics platform for primary care clinics across the UAE.",
  },
  {
    id: "D1016",
    name: "GCC Fintech Platform",
    sector: "Fintech",
    geography: "MEA",
    owners: "VC-backed",
    stage: "Sourced",
    investmentType: "VC",
    score: 70,
    enterpriseValue: 50,
    ebitdaMargin: 5,
    revenueYoY: 85,
    updatedAt: Date.now() - 86400 * 1 * 1000,
    description: "Sharia-compliant digital banking and payments platform for GCC SMEs.",
  },
];

// ─── LP Data (GII-style) ──────────────────────────────────────────────────────
const GII_LPS = [
  { id: "L301", name: "Abu Dhabi Investment Authority", type: "Sovereign Wealth", committed: 150, called: 95, contact: "ir@adia.ae", transparencyPref: "Quarterly" },
  { id: "L302", name: "Saudi Public Investment Fund", type: "Sovereign Wealth", committed: 200, called: 120, contact: "ir@pif.gov.sa", transparencyPref: "Quarterly" },
  { id: "L303", name: "Mubadala Investment Company", type: "Sovereign Wealth", committed: 100, called: 68, contact: "ir@mubadala.ae", transparencyPref: "Monthly" },
  { id: "L304", name: "Emirates NBD Capital", type: "FoF", committed: 75, called: 42, contact: "capital@emiratesnbd.com", transparencyPref: "Monthly" },
  { id: "L305", name: "GCC Family Office Consortium", type: "Family Office", committed: 50, called: 28, contact: "invest@gccfamilyoffice.com", transparencyPref: "Bi-weekly" },
  { id: "L306", name: "Kuwait Investment Authority", type: "Sovereign Wealth", committed: 120, called: 80, contact: "ir@kia.gov.kw", transparencyPref: "Quarterly" },
  { id: "L307", name: "Bahrain Mumtalakat Holding", type: "Sovereign Wealth", committed: 60, called: 35, contact: "ir@mumtalakat.bh", transparencyPref: "Monthly" },
  { id: "L308", name: "Qatar Investment Authority", type: "Sovereign Wealth", committed: 180, called: 110, contact: "ir@qia.qa", transparencyPref: "Quarterly" },
  { id: "L309", name: "India Growth Partners", type: "Endowment", committed: 40, called: 22, contact: "ir@igp.in", transparencyPref: "Monthly" },
  { id: "L310", name: "MENA Ventures Endowment", type: "Endowment", committed: 35, called: 18, contact: "ir@menaventures.com", transparencyPref: "Bi-weekly" },
];

// ─── Seed / Access Functions ──────────────────────────────────────────────────
export function seedIfEmpty() {
  if (!localStorage.getItem(STORAGE_KEYS.deals)) localStorage.setItem(STORAGE_KEYS.deals, JSON.stringify(GII_DEALS));
  if (!localStorage.getItem(STORAGE_KEYS.portfolio)) localStorage.setItem(STORAGE_KEYS.portfolio, JSON.stringify(GII_PORTFOLIO));
  if (!localStorage.getItem(STORAGE_KEYS.lps)) localStorage.setItem(STORAGE_KEYS.lps, JSON.stringify(GII_LPS));
  if (!localStorage.getItem(STORAGE_KEYS.audit)) localStorage.setItem(STORAGE_KEYS.audit, JSON.stringify([]));
  if (!localStorage.getItem(STORAGE_KEYS.activities)) localStorage.setItem(STORAGE_KEYS.activities, JSON.stringify([]));
}

export function reseedAll() {
  localStorage.setItem(STORAGE_KEYS.deals, JSON.stringify(GII_DEALS));
  localStorage.setItem(STORAGE_KEYS.portfolio, JSON.stringify(GII_PORTFOLIO));
  localStorage.setItem(STORAGE_KEYS.lps, JSON.stringify(GII_LPS));
  localStorage.setItem(STORAGE_KEYS.audit, JSON.stringify([]));
  localStorage.setItem(STORAGE_KEYS.activities, JSON.stringify([]));
  // Clear all cached filters and campaigns
  localStorage.removeItem("atlas_pipeline_filters");
  localStorage.removeItem("atlas_sourcing_campaigns");
}

// Get current team from localStorage
export function getCurrentTeam() {
  return localStorage.getItem("atlas_team") || "PE Investment";
}

// Filter data based on team
function filterByTeam(data) {
  const team = getCurrentTeam();
  if (team === "Hybrid") {
    return data; // Return all data for Hybrid
  } else if (team === "PE Investment") {
    return data.filter(item => item.investmentType === "PE");
  } else if (team === "VC Investment") {
    return data.filter(item => item.investmentType === "VC");
  }
  return data;
}

// Get all data without filtering (for internal use)
export const getAllDeals = () => JSON.parse(localStorage.getItem(STORAGE_KEYS.deals) || "[]");
export const getAllPortfolio = () => JSON.parse(localStorage.getItem(STORAGE_KEYS.portfolio) || "[]");

// Get filtered data based on team selection
export const getDeals = () => filterByTeam(getAllDeals());
export const getPortfolio = () => filterByTeam(getAllPortfolio());
export const getLPs = () => JSON.parse(localStorage.getItem(STORAGE_KEYS.lps) || "[]");
export const getPortfolioCompanies = () => getPortfolio();
export const getAuditLog = () => JSON.parse(localStorage.getItem(STORAGE_KEYS.audit) || "[]");

export function logAction(actor, action, entityType, entityId, meta = {}) {
  const entry = { id: crypto.randomUUID(), ts: Date.now(), actor, action, entityType, entityId, meta };
  const log = getAuditLog();
  log.unshift(entry);
  localStorage.setItem(STORAGE_KEYS.audit, JSON.stringify(log));
}

export function saveDeals(deals) { localStorage.setItem(STORAGE_KEYS.deals, JSON.stringify(deals)); }

export function moveDealStage(id, direction = 1) {
  const deals = getAllDeals();
  const idx = deals.findIndex(d => d.id === id);
  if (idx === -1) return deals;
  const sIdx = stages.indexOf(deals[idx].stage);
  deals[idx].stage = stages[Math.min(Math.max(sIdx + direction, 0), stages.length - 1)];
  deals[idx].updatedAt = Date.now();
  saveDeals(deals);
  logAction("system", "move_stage", "deal", id, { stage: deals[idx].stage });
  return deals;
}

export function updateDeal(id, patch) {
  const deals = getAllDeals().map(d => d.id === id ? { ...d, ...patch, updatedAt: Date.now() } : d);
  saveDeals(deals);
  logAction("system", "update", "deal", id, { patch });
  return deals.find(d => d.id === id);
}

export const getStages = () => stages;

/* Mock AI utilities (frontend-only placeholder — swap to backend LLM with API key) */
export async function mockAIRespond(kind, prompt, context = {}) {
  const templates = {
    score: () => `Deal scoring rationale: ${prompt}\nSignals considered: GCC market dynamics, EBITDA margin, revenue growth, sector tailwinds in MENA.\nConfidence: ${(70 + Math.random()*25).toFixed(0)}%. Key risks: ${pick(["regulatory environment","currency exposure","customer concentration","founder dependency","regional geopolitics"])}`,
    market: () => `Top market signals for GII: ${pick(["KSA Vision 2030 driving healthcare privatisation","UAE F&B sector growing 8% YoY","India consumer brands attracting global PE","MENA EdTech adoption accelerating post-COVID","GCC logistics infrastructure investment surging"]) }.`,
    negotiate: () => `Negotiation draft: Offer EV ${Math.round(8+Math.random()*12)}x LTM EBITDA, ${pick(["with earnout tied to GCC expansion milestones","with seller rollover at 20%","including TSA for 12 months","with MAC clause for regional regulatory changes"]) }. ${pick(["Tighten reps & warranties on regulatory compliance","Request QoE adjustment for IFRS differences","Ask for WCap peg at 3-month average","Adjust for Zakat and VAT liabilities"]) }.`,
    summary: () => `Executive summary: ${pick(["strong unit economics with GCC tailwinds","defensible market position in MENA","sticky B2B contracts with government entities","healthy expansion trajectory across KSA and UAE","efficient capital deployment with Sharia-compliant structure"]) } with ${pick(["moderate","low","manageable"]) } risk profile.`,
  };
  await new Promise(r => setTimeout(r, 600 + Math.random() * 600));
  return templates[kind] ? templates[kind]() : `AI: ${prompt}`;
}

export function activitiesLog(activity) {
  const arr = JSON.parse(localStorage.getItem(STORAGE_KEYS.activities) || "[]");
  arr.unshift({ id: crypto.randomUUID(), ts: Date.now(), ...activity });
  localStorage.setItem(STORAGE_KEYS.activities, JSON.stringify(arr));
}

export const getActivities = () => JSON.parse(localStorage.getItem(STORAGE_KEYS.activities) || "[]");
